import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import VerseOfTheDay from '../../components/home/VerseOfTheDay';
import EnrolledCourses from '../../components/home/EnrolledCourses';
import RecentPost from '../../components/home/RecentPost';
import { theme } from '../../styles/theme';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const WelcomeMessage = styled.div`
  margin-bottom: ${theme.spacing.lg};
  
  h1 {
    font-size: ${theme.fontSizes.xxxlarge};
    margin-bottom: ${theme.spacing.sm};
  }
  
  p {
    font-size: ${theme.fontSizes.large};
    color: ${theme.colors.gray};
  }
`;

const HomePage: React.FC = () => {
  const { user } = useAuth();
  
  return (
    <HomeContainer>
      <WelcomeMessage>
        <h1>Welcome, {user?.name || 'Friend'}!</h1>
        <p>Grow in faith through stories, courses, and community.</p>
      </WelcomeMessage>
      
      <VerseOfTheDay />
      <EnrolledCourses />
      <RecentPost />
    </HomeContainer>
  );
};

export default HomePage; 